export default {
  "termsOfUse": "Условия использования",
  "goToHome": "Перейти на главную страницу",
  "choose": "Выбрать",
  "close": "Закрыть",
  "yes": "Да",
  "no": "Нет",
  "moreInfo": "Больше информации",
  "send": "Отправить",
  "sendProcess": "Отправка",
  "sendSuccess": "Отправлено",
  "actual": "Актуально",
  "question": "Проконсультироваться с врачом",
  "appointment": "Записаться к врачу",
  "freeDownload": "Скачайте бесплатно наше приложение",
  "downloadAppStore": "Загрузите в App Store",
  "downloadGooglePlay": "Загрузите в Google Play",
  "month": "Месяц",
  "year": "Год",
  "other": "Другие",
  "backToStart": "Вернуться в начало",
  "backToOverview": "Назад к списку услуг",
  "or": "или",
  "czechLanguage": "Чешский",
  "slovakLanguage": "Словацкий",
  "englishLanguage": "Английский",
  "goNext": "Продолжить",
  "goPrev": "назад",
  "save": "Сохранить",
  "show": "Показать",
  "showMore": "Показать больше",
  "showAll": "Показать всё",
  "saveChanges": "Сохранить изменения",
  "saveChangesProcess": "Сохранение",
  "saveChangesSuccess": "Сохранено",
  "loginText": "Войти",
  "contact": "Контакт",
  "done": "Готово",
  "finish": "Завершить",
  "skip": "Пропустить",
  "legalDocuments": "Правовые документы",
  "new": "Новинка",
  "free": "Бесплатно",
  "tryAgain": "Попробовать снова",
  "until": "до",
  "pilot": "Видеозвонок",
  "here": "здесь",
  "currency": "CZK",
  "agree": "Я согласен",
  "disagree": "Не согласен",
  "alertInfo": {
    "title": "Медицинская консультация uLékaře.cz не является заменой скорой медицинской помощи.",
    "text": "При острой необходимости <a href='tel:155'>звоните по телефону 155 или 112</a>",
    "errorText": "Это поле обязательно для заполнения."
  },
  "uLekare": {
    "title": "uLékaře.cz"
  },
  "partners": {
    "otherPartners": "Партнеры"
  },
  "questionForm": {
    "title": "Ваш вопрос врачу",
    "subtitle": "Что вас беспокоит, как долго продолжается проблема, принимаете ли какие-либо лекарства, были ли уже какие-либо обследования, ...",
    "modalTitle": "Прикрепите фото или выписки от врача",
    "send": "Послать врачу",
    "back": "Вернуться к вопросу",
    "sendTitle": "Благодарим за отправку вопроса",
    "next": "Продолжить",
    "sendPerex": "Благодарим за ваш визит в Виртуальную приемную",
    "question": {
      "placeholder": "Напишите здесь, что вас беспокоит",
      "errorText": "Пожалуйста, заполните вопрос для врача, чтобы он мог вас проконсультировать."
    },
    "firstName": {
      "title": "Имя",
      "placeholder": "Введите имя",
      "helpText": "Мы отобразим ваше имя в запросе на сайте.",
      "helpTextNotShowing": "Медицинский персонал будет общаться с вами, поэтому им нужно ваше имя.’",
      "errorText": "Имя обязательно для заполнения, пожалуйста, укажите его."
    },
    "lastName": {
      "title": "Фамилия",
      "placeholder": "Введите фамилию",
      "helpText": "Медицинский персонал будет общаться с вами, поэтому им нужна ваша фамилия.",
      "errorText": "Фамилия обязательна для заполнения, пожалуйста, укажите ее."
    },
    "email": {
      "title": "Электронна почта",
      "placeholder": "имя@пример.cz",
      "helpText": "Мы будем общаться с вами по электронной почте.",
      "hrbHelpText": "Рекомендуем указать личную электронную почту.",
      "errorText": "Электронная почта обязательна для заполнения, пожалуйста, укажите ее.",
      "errorEmailText": "Некорректный адрес электронной почты.",
      "errorEmailNotExisting": "Пожалуйста, укажите существующий адрес электронной почты.",
      "invalidBenefitEmail": "Неверный адрес электронной почты"
    },
    "phone": {
      "title": "Телефон",
      "placeholder": "123 456 789",
      "helpText": "Медсестра может помочь вам записаться к врачу.",
      "errorText": "Номер телефона обязателен, пожалуйста, укажите его.",
      "errorPhoneText": "Введите номер телефона ({exampleNumber})."
    },
    "emailphone": {
      "errorEmailText": "Электронная почта или номер телефона обязательны. Пожалуйста, укажите один из контактных способов.",
      "errorPhoneText": "Номер телефона или электронная почта обязательны. Пожалуйста, укажите один из контактных способов."
    },
    "birthYear": {
      "title": "Год рождения",
      "titleRegistered": "Год рождения пациента",
      "helpText": "Год рождения человека, о проблеме которого вы спрашиваете.",
      "errorText": "Год рождения обязателен, пожалуйста, укажите его.",
      "errorLengthText": "Введите год рождения в четырехзначном формате.",
      "errorBetweenText": "Введите реальный год рождения."
    },
    "pastYear": {
      "errorLengthText": "Введите год в четырехзначном формате.",
      "errorBetweenText": "Введите реальный год.",
      "errorText": "Год обязателен, пожалуйста, укажите его."
    },
    "zipCode": {
      "title": "Почтовый индекс",
      "helpText": "По почтовому индексу мы порекомендуем, куда записаться.",
      "errorText": "Почтовый индекс обязателен, пожалуйста, укажите его.",
      "errorZipCodeText": "Почтовый индекс имеет неверный формат."
    },
    "insuranceCompany": {
      "title": "Страховая компания",
      "errorText": "Это поле обязательно. Пожалуйста, выберите страховую компанию.",
      "selectInsuranceCompany": "Выберите свою страховую компанию"
    },
    "timeAvailability": {
      "title": "Ваше время доступности",
      "errorText": "Это поле обязательно. Пожалуйста, укажите свое время доступности.",
      "placeholder": "Укажите, какие у вас временные возможности в ближайшие дни."
    },
    "selectedBranchValue": {
      "title": "Кабинет врача",
      "selectInsuranceCompany": "Выберете кабинет врача"
    },
    "personalId": {
      "title": "Номер страховки",
      "helpText": "Используется для проверки вашей регистрации у семейного врача.",
      "errorText": "Это поле обязательно. Пожалуйста, укажите номер страховки."
    },
    "checkedMyDoctor": "Я проверил, что это мой семейный врач"
  },
  "fileUpload": {
    "initial": "Нажмите «Выбрать» и выберите файлы или перетащите их.",
    "typeError": "Данный тип файла не подходит. Добавляйте файлы следующих типов .jpg, .png.",
    "sizeError": "Превышен максимальный допустимый размер. Максимальный размер одного файла 20 МБ, слитно 100 МБ.",
    "totalSizeError": "Максимальный размер файлов слитно 100 МБ."
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "Компания uLékaře.cz",
    "companyList": [
      {
        "title": "Контакт"
      },
      {
        "title": "Карьера",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Реклама",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Здоровье и профилактика на работе",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Принципы обработки персональных данных",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing",
        "aeskulabLink": "aeskuLabPersonalDataProcessing"
      },
      {
        "title": "Условия использования",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions",
        "aeskulabLink": "aeskuLabTermsAndConditions"
      },
      {
        "title": "Сообщение о файлах cookie",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies",
        "aeskulabLink": "aeskuLabCookies"
      }
    ],
    "perex": {
      "rsAssistant": "Самая большая онлайн медицинская консультация и пионер в области телемедицины ставит перед собой цель повысить эффективность и качество чешской медицинской системы.<br/><br/>CZ2212160829/12/2022",
      "astmaHelp": "Самая большая онлайн медицинская консультация и пионер в области телемедицины ставит перед собой цель повысить эффективность и качество чешской медицинской системы.",
      "forCompanies": "В uLékaře.cz мы верим, что Ваше здоровье - в Ваших руках. Объединяя технологий, человеческий подход и профессиональное мнение врачей мы помогаем людям контролировать свое здоровье. Команда из более чем 350 врачей всех специализаций каждый день в распоряжении более чем 100 тысяч пользователей."
    },
    "mottos": [
      "Человечность",
      "Энтузиазм",
      "Профессионализм",
      "Инновации"
    ]
  },
  "dataProcessing": {
    "iAgree": "Соглашаюсь",
    "iAgreeWith": "Соглашаюсь с",
    "privacyPolicy": "обработкой персональных данных",
    "privacyPolicyTitle": "Согласие на обработку персональных данных, включая особые категории персональных данных",
    "newsletterProcessing": "рассылкой новостей и скидок uLékaře.cz.",
    "newsletterText": "Соглашаюсь на получение маркетинговых сообщений от uLékaře.cz (с сообщениями о компании и проекте uLékaře.cz, s.r.o., или о продуктах и услугах сотрудничающих третьих лиц). Согласие можно отозвать в рассылке или по адресу <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterAgreement": "рассылкой сообщений о конференции",
    "conferenceNewsletterTitle": "Согласие на получение информационных писем (рассылок)",
    "conferenceDataTitle": "Соглашаюсь на обработку персональных данных",
    "termsConditions": "условиями использования",
    "privacyPolicyInAccordance": "Личные данные обрабатываются в соответствии с"
  },
  "termsAndConditions": {
    "title": "Условия использования"
  },
  "personalDataProcessing": {
    "title": "Согласие на обработку персональных данных"
  },
  "newsletter": {
    "title": "Согласие на получение маркетинговых сообщений"
  },
  "errorLayout": {
    "title": "Упс, эта страница на больничном!",
    "text": "Извините, эта страница уже на операции. Мы скоро ее восстановим, пожалуйста, попробуйте позже.",
    "button": "Вернуться на главную страницу"
  },
  "meta": {
    "termsAndConditions": {
      "title": "Особые условия использования веб-сайта uLékaře.cz"
    },
    "personalDataProcessing": {
      "title": "Принципы защиты персональных данных"
    },
    "emergency": {
      "title": "Когда обратиться в скорую помощь",
      "description": "Stručný soupis akutních nebo život ohrožujících stavů, na které chceme upozornit pacienty s cílem nasměrovat to nejurgentnější na pohotovost."
    },
    "putinSucks": {
      "title": "Врачебная консультация для беженцев из Украины",
      "description": "Бесплатная помощь и запись по всей Чехии. Персонал говорит на украинском и русском языках."
    },
    "login": {
      "title": "Вход",
      "description": "Зарегистрируйтесь, чтобы всегда иметь медицинскую помощь под рукой. Мы с удовольствием поможем вам также с записью к врачу в Чехии и Словакии. Ваше здоровье важно."
    },
    "aeskulab": {
      "title": "Мои результаты анализов"
    },
    "dashboard": {
      "title": "Здоровье онлайн"
    },
    "dashboardQuestions": {
      "title": "Советы"
    },
    "dashboardAppointments": {
      "title": "Запись на прием к врачу"
    },
    "dashboardArticles": {
      "title": "Журнал Discover"
    },
    "dashboardConsultations": {
      "title": "Ответы врачей"
    },
    "dashboardPrevention": {
      "title": "Моя профилактика"
    },
    "dashboardProfile": {
      "title": "Мой профиль здоровья"
    },
    "lostPassword": {
      "title": "Забыли пароль"
    },
    "passwordReset": {
      "title": "Сброс пароля"
    },
    "emailVerification": {
      "title": "Проверка электронной почты"
    },
    "registration": {
      "title": "Зарегистрироваться"
    }
  },
  "emergency": {
    "title1": "Когда обратиться в скорую помощь",
    "perex": "Это краткое изложение острых или угрожающих жизни состояний, на которые мы хотим обратить внимание пациентов с целью направить наиболее срочные случаи в службу скорой помощи, чтобы избежать задержек в лечении, ожидая ответа врача в онлайн-консультации. Особая предусмотрительность необходима в случае детей.",
    "list": [
      {
        "title": "Травмы и кровотечение",
        "body": [
          "сильное кровотечение, или <strong> пульсирующее кровотечение ярко-красного цвета</strong>",
          "сильное кровотечение из половых органов вне менструального цикла или из прямой кишки",
          "открытый или иным образом очевидный перелом",
          "<strong>открытые раны</strong> грудной клетки или живота",
          "<strong>травмы головы</strong> с потерей сознания, изменениями поведения, головной болью, рвотой, различным размером зрачков, нарушениями речи, зрения или подвижности",
          "<strong>ожоги у детей</strong>, особенно на голове и руках, в области половых органов или на большой поверхности тела у взрослого",
          "Повреждения, <strong>вызванные электрическим током или ударом молнии</strong>"
        ]
      },
      {
        "title": "Боли и иные ощущения в груди",
        "body": [
          "Боль в груди, которая <strong>не утихает</strong>, не реагирует на обычные обезболивающие препараты или усиливается, <strong>давящая</strong>",
          "<strong>стреляющая</strong> в левое плечо или шею",
          "Боль или <strong>нарушение ритма сопровождается изменением сознания</strong>, обмороками",
          "если у вас повторяются подобные симптомы или если у вас есть заболевания сердечно-сосудистой системы",
          "боль в груди с одышкой и значительными изменениями в давлении"
        ]
      },
      {
        "title": "Затруднение дыхания",
        "body": [
          "невозможность нормального дыхания, ощущение <strong>недостатка воздуха</strong>",
          "<strong>неправильное дыхание</strong>, сиплое дыхание, свистящие выдохи",
          "невозможность завершения предложения без вдоха, необходимость сидеть или опираться на руки для улучшения дыхания, углубление ямки между плечами и шеей",
          "<strong>изменение цвета</strong> губ, ушей или пальцев на фиолетовый"
        ]
      },
      {
        "title": "Боль головы",
        "body": [
          "боль является <strong>мучительной, необычной, внезапно</strong> возникшей, не реагирует на лекарства",
          "<strong>будит ночью</strong>, или возникает сразу после пробуждения",
          "перед внезапной болью было значительное физическое напряжение, включая сексуальную активность",
          "боль сопровождается жесткостью мышц шеи, слабостью, сонливостью, нарушениями сознания, лихорадкой",
          "головная боль в ближайшие дни после травмы головы, особенно с нарушением сознания, рвотой, головокружением",
          "сопровождающаяся <strong>нарушениями зрения, речи, подвижности</strong>"
        ]
      },
      {
        "title": "Боль в животе и проблемы пищеварительной системы",
        "body": [
          "<strong>острая или спазматическая</strong> боль в животе",
          "<strong>задержка стула</strong> или газов с вздутием живота, боли",
          "черный стул",
          "<strong>рвота кровью</strong>",
          "<strong>опухоль в животе</strong>, в паховой области, на яичке, которая болит, не удается вдавить (не пытайтесь это делать), имеет иной цвет по сравнению с окружающей областью"
        ]
      },
      {
        "title": "Обмороки, нарушение сознания, судороги.",
        "body": [
          "внезапный обморок, падение, после которого пострадавший не просыпается или ведет себя необычно",
          "состояния с <strong>нарушением сознания, речи, зрения, движения конечностей</strong>",
          "<strong>судороги всего тела</strong>"
        ]
      },
      {
        "title": "Инфекции и лихорадки",
        "body": [
          "состояния, сопровождающиеся <strong>температурой выше 40 °C, которую не получается сбить соответствующей дозой лекарства</strong>",
          "<strong>озно у детей, судороги у детей при лихорадке</strong>",
          "повторные <strong> рвота и понос у детей</strong>, недостаточный прием жидкостей у детей",
          "инфекции, сопровождающиеся общими изменениями состояния/поведения, такими как выраженная сонливость, апатия, неспособность есть и пить"
        ]
      },
      {
        "title": "Аллергия и отеки",
        "body": [
          "<strong>отек лица, шеи и внутри горла, отек языка</strong>",
          "<strong>затруднение дыхания</strong>",
          "<strong>трудности с глотанием</strong>",
          "общие проявления, такие как сыпь или отек",
          "односторонний, болезненный отек конечности, с возможным затруднением дыхания или сухим кашлем"
        ]
      },
      {
        "title": "Стоматологическая неотложная помощь",
        "body": [
          "боль в зубах с выраженной головной болью",
          "боль в зубах с температурой",
          "отеки лица и области зубов, распространяющиеся на шею или сопровождаемые трудностями с глотанием"
        ]
      },
      {
        "title": "Преступления",
        "body": [
          "в случае подозрения на преступление, наберите 112",
          "если речь идет о угрозе Вашей жизни или жизни кого-то из ваших близких в результате преступления, наберите 112",
          "если речь идет о травле, физическом или душевном насилии, наберите 112"
        ]
      },
      {
        "title": "Психическое состояние",
        "body": [
          "если речь идет о внезапном состоянии путаницы, изменениях поведения, агрессии, вызовите скорую помощь",
          "если речь идет о угрозе самоубийства, вызовите скорую помощь"
        ]
      }
    ],
    "title2": "Звоните 155",
    "title": "Когда обратиться в скорую помощь"
  },
  "emergencyInfo": {
    "titleQuestion": "Прежде чем задать вопрос",
    "titleonco-prevention": "Прежде чем задать вопрос",
    "titleOrder": "Прежде чем разместить заказ",
    "subtitle": "Служба uLékaře.cz не заменяет службу неотложной помощи.<br /><a href=\"{link}\" target=\"_blank\" class=\"black--text link--inline\">Когда звонить в отделение неотложной помощи?</а>",
    "services": "В острых и опасных для жизни ситуациях всегда <a href=\"tel:155\" class=\"link--inline black--text\">звоните по номеру 155 или 112</a>.",
    "continueQuestion": "Продолжить запрос",
    "continueOrder": "Продолжить в порядке",
    "dynamicForms": {
      "linkText": "Когда обращаться за неотложной помощью"
    }
  },
  "reauthorizationDashboard": {
    "partnerText": "Услуга uLékaře.cz по-прежнему оплачивается {currentPartnerName}.",
    "prolongText": "Продлите свои преимущества uLékaře.cz, чтобы сохранить их бесплатными.",
    "prolongFamilyText": "Напомните своему любимому человеку, что вы хотели бы продлить услугу.",
    "buttonText": "Продлить бесплатно",
    "inDay": "дней",
    "inDaysLow": "дней",
    "inDaysHigh": "дней",
    "selfPayNowHeading": "Теперь вы платите за себя сами. Но это не обязательно.",
    "selfPayNowPartnerText": "Кто будет платить за uLékaře.cz? Это может быть ваш работодатель, страховая компания и т. д.",
    "selfPayNowProlongText": "Расширьте свои льготы, чтобы получить услугу бесплатно. Как и раньше.",
    "selfPayNowFamilyPartnerText": "Напомните об этом своему близкому человеку {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "Когда они продлят обслуживание на uLékaře.cz, вы получите все свои льготы бесплатно."
  },
  "hrbPage": {
    "contactUs": {
      "title": "Служба поддержки",
      "subTitle": "Не уверены, как действовать? Требуется помощь при заполнении формы?"
    },
    "covidLink": {
      "title": "Горячая линия Covid",
      "callUs": "Позвоните нам",
      "tooltip": {
        "title": "С чем вам можем помочь?",
        "text": [
          "Симптомы болезни",
          "Группы риска",
          "Коронавирус и беременность",
          "Тестирование",
          "Профилактические и гигиенические меры"
        ]
      }
    }
  },
  "authorization": {
    "title": "Активация услуги",
    "subtitle": "Чтобы начать пользоваться услугой, введите свой корпоративный e-mail или код, который вы получили от работодателя. Затем следуйте инструкциям.",
    "subtitleEmail": "Чтобы начать пользоваться услугой, введите свой корпоративный e-mail, который вы получили от работодателя. Затем следуйте инструкциям.",
    "subtitleCode": "Чтобы начать пользоваться услугой, введите код, который вы получили от работодателя. Затем следуйте инструкциям.",
    "emailLabel": "E-mail",
    "codeLabel": "Код",
    "codeHrbError": "Недействительный код",
    "codeLengthError": "Неверный формат. Код должен содержать от 2 до 20 символов.",
    "or": "или",
    "contactTitle": "Не знаете, что делать?",
    "sendMessage": "Мы отправили запрос на использование услуги uLékaře.cz на ваш <strong class=\"text-primary\">{email}</strong>. Одобрение запроса осуществляется по ссылке в письме.",
    "changeEmail": "Изменить e-mail"
  },
  "checkToken": {
    "generateToken": "Послать новую ссылку",
    "expired": {
      "title": "Срок действия ссылки истек",
      "perex": "По соображениям безопасности ссылки имеют ограниченный срок действия. Попробуйте запросить новую ссылку."
    },
    "invalid": {
      "title": "Ссылка уже недействительна",
      "perex": "Указанная ссылка уже не работает. Это может быть связано с её использованием или изменением условий."
    },
    "tokenCreated": {
      "title": "Ссылка была отправлена.",
      "perex": "На Ваш корпоративный адрес электронной почты мы отправили новую ссылку. Активацию завершите, нажав на эту ссылку в письме."
    }
  },
  "preventionForm": {
    "birthDate": {
      "title": "Дата рождения",
      "errorText": "Впишите дату рождения.",
      "errorTextDate": "Дата рождения указана в неправильном формате.",
      "errorTextBirthDateRange": "Укажите дату рождения правильно."
    },
    "gender": {
      "title": "Пол",
      "selectGender": "Выберите пол",
      "errorText": "Выберите пол.",
      "male": "Мужчина",
      "female": "Женщина",
      "other": "Другой"
    },
    "address": {
      "placeholder": "Введите свое местоположение"
    }
  },
  "ulekareContacts": {
    "email": "info@ulekare.cz",
    "phone": " +420&nbsp;227&nbsp;072&nbsp;720",
    "hours": "Пн-Пт 8.00–17.00&nbsp;ч"
  },
  "authorizationPage": {
    "successText": "Подтверждение прошло успешно, у вас есть право на бесплатное обслуживание",
    "prevention": {
      "title": "Благодарим. Авторизация прошла успешно.",
      "subtitle": "Перейдите по ссылке, отправленной вам на почту <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "renewPassword": {
    "title": "Сброс пароля",
    "subtitle": "Создайте новый пароль для вашей учетной записи. Мы рекомендуем создать более надежный пароль, содержащий как минимум одну цифру и букву.",
    "setPassword": "Введите пароль",
    "setPasswordAgain": "Введите пароль еще раз",
    "newPassword": "Новый пароль",
    "changePassword": "Изменить пароль",
    "minLengthError": "Пароль должен содержать минимум 5 символов.",
    "requiredErrorText": "Укажите пароль (мин. 5 символов).",
    "generatedError": {
      "start": "Пароль должен",
      "minLength": "иметь минимальную длину в {length} символов",
      "and": "и",
      "require": "содержать",
      "oneChar": "буква",
      "oneNumber": "цифры",
      "specialChar": "специальный символ"
    },
    "sameAsPasswordErrorText": "Пароли не совпадают.",
    "successMessage": "Пароль успешно изменен.",
    "invalidToken": {
      "title": "Недействительная ссылка",
      "perex": "Сгенерируйте новую ссылку, нажав \"Забыли пароль\" в мобильном приложении uLékaře.cz."
    },
    "usedToken": {
      "perex": "Эта ссылка больше не действительна, так как она уже была использована."
    },
    "expiredToken": {
      "title": "Срок действия ссылки истек.",
      "perex": "Сгенерируйте новую ссылку, нажав \"Забыли пароль\" в мобильном приложении uLékaře.cz."
    },
    "nextButton": "Войдите на {service}"
  },
  "emailVerification": {
    "successMessagePerex": "Мы успешно подтвердили ваш адрес электронной почты. Вы можете войти.",
    "button": "Продолжить {service}",
    "invalidToken": "Ссылка недействительна.",
    "usedToken": "Эта ссылка больше не действительна, так как она уже использовалась один раз.",
    "expiredToken": "Срок действия ссылки истек."
  },
  "unsupportedBrowser": {
    "title": "Используйте другой браузер",
    "perex": "Версия браузера, который вы используете, больше не поддерживает нашу службу. Пожалуйста, обновите его или используйте один из следующих браузеров."
  },
  "login": {
    "banner": {
      "title": "Ваши данные останутся в сохранности.",
      "subtitle": "Постоянно работаем над улучшением uLékaře.cz, чтобы ваши данные оставались только вашими."
    },
    "socials": {
      "facebook": "Войти с помощью Facebook",
      "google": "Войти с помощью Google",
      "apple": "Войти с помощью Apple"
    },
    "title": "Войти",
    "subtitle": "Для использования услуг uLékaře.cz необходимо войти",
    "loginError": "Возможно опечатка, возможно неправильные данные. Пожалуйста, попробуйте еще раз.",
    "forgetPassword": "Забыли пароль?",
    "password": {
      "title": "Пароль",
      "requiredError": "Необходим пароль"
    },
    "remember": "Запомнить данные для входа",
    "login": "Войти",
    "noAccount": "У вас еще нет врача под рукой?",
    "registration": "Зарегистрируйтесь.",
    "registrationHeaderButton": "Зарегистрируйтесь"
  },
  "registration": {
    "title": "Регистрация",
    "subtitleFirstStep": "Зарегистрируйтесь, чтобы пользоваться услугами uLékaře.cz.",
    "subtitle": "Ваши данные известны только команде uLékaře.cz.",
    "addData": {
      "title": "Дополнение данных",
      "subtitle": "Вы вошли! Добавьте свои личные данные, чтобы с вами мог взаимодействовать медицинский персонал."
    },
    "emailError": "Этот адрес электронной почты уже зарегистрирован.",
    "email": {
      "errorEmailNotExisting": "Введите существующий адрес электронной почты.",
      "errorInvalidDomain": "Пожалуйста, используйте адрес электронной почты с разрешенным доменом (например @seznam.cz, @gmail.com...)",
      "errorText": "Пожалуйста, укажите адрес электронной почты.",
      "title": "Личная почта"
    },
    "socials": {
      "facebook": "Зарегистрироваться через Facebook",
      "google": "Зарегистрироваться через Google",
      "apple": "Зарегистрироваться через Apple"
    },
    "loginText": {
      "link": "Войдите",
      "suffix": ", пожалуйста",
      "question": "Этот адрес электронной почты уже зарегистрирован."
    },
    "login": {
      "text": "У вас уже есть аккаунт?",
      "link": "Войдите."
    },
    "finishRegistration": "Завершить регистрацию",
    "legal": {
      "text": "Соглашаюсь с {termsAndConds}.",
      "termsConditions": "условиями использования",
      "privacyPolicy": "Принципами защиты персональных данных."
    }
  },
  "missingProfileData": {
    "title": "Дополнение данных",
    "titleLegal": "Подтверждение согласий",
    "text": "Нам не удалось получить ваш адрес электронной почты из связанного аккаунта, необходимый для предоставления наших услуг. Пожалуйста, укажите его ниже.",
    "textLegal": "Пожалуйста, подтвердите следующее:"
  },
  "phoneVerification": {
    "title": "Подтверждение номера телефона",
    "subtitle": "На ваш номер телефона {phone} мы отправили проверочный код в SMS. Пожалуйста, введите его ниже.",
    "label": "Код из SMS",
    "changeNumber": "Сменить номер",
    "inputError": "Поле для кода необходимо заполнить.",
    "codeError": "Введенный код недействителен. Нужна помощь?",
    "sendAgain": "Послать код еще раз",
    "verify": "Проверить",
    "error": {
      "error_timeout": {
        "title": "Пожалуйста, подождите получения подтверждающего SMS",
        "perex": "По всей видимости, вы запросили изменение номера телефона несколько раз подряд. Пожалуйста, подождите, чтобы избежать получения нескольких сообщений одновременно"
      },
      "error_block": {
        "title": "Мы заблокировали ваш аккаунт. Для уверенности...",
        "perex": "Безопасность для нас на первом месте, поэтому из-за подозрительной активности мы временно заблокировали ваш аккаунт. Наша служба поддержки готова вам помочь.",
        "callUs": "Позвоните нам",
        "writeUs": "Напишите нам"
      }
    }
  },
  "lostPassword": {
    "title": "Забытый пароль",
    "subtitle": "Ссылку для восстановления пароля Вы получите, если Вы зарегистрированы на нашем сайте или в мобильном приложении с использованием этого адреса электронной почты.",
    "button": "Обновить пароль",
    "linkSentTitle": "Отправлено",
    "linkSentPerex": "E-mail для обновления пароля был отправлен на {email}. Если Вы не найдете его в своей электронной почте, посмотрите в папке “Спам”",
    "sendLinkAgain": "Послать e-mail еще раз",
    "finishRegistration": "Завершить регистрацию"
  },
  "profileSection": {
    "menu": {
      "profile": "Мой аккаунт",
      "subscription": "Подписка",
      "logout": "Выйти"
    },
    "badge": {
      "self": "оплачиваю сам",
      "premium": "оплачено"
    },
    "freeService": {
      "title": "Бесплатная служба",
      "text": "Служба частно оплачивается партнерами, работодателями или страховыми.",
      "button": "Я имею право?"
    },
    "thankYou": "Службу вам оплачивает {partnerName}.",
    "thankYouSelf": "Службу оплачиваете вы.",
    "thankYouHost": "Службу вам оплачивает {host}."
  },
  "dashboard": {
    "menu": {
      "home": "Обзор",
      "questions": "Консультация",
      "appointments": "Запись",
      "prevention": "Профилактика",
      "explore": "Исследовать"
    },
    "personalInfoAssurance": {
      "prefix": "Как с вами будем общаться?",
      "email": "E-mail",
      "phone": "Телефон"
    },
    "deactivatedUser": "<strong>Ваш аккаунт деактивирован.</strong> <span class=\"black--text\">Что произошло? Свяжитесь с нами: <a href=\"mailto:{email}\">{email}</a> или по тел. {phone}.</span>",
    "title": "Приветствуем! 👋",
    "subtitle": "Как мы вам можем помочь?",
    "needAdvice": "Написать вопрос",
    "needAppointment": "Запись к врачу",
    "needHelp": "Нужна помощь?",
    "supportBox": {
      "openTitle": "Важные контакты",
      "title": "Поддержка клиентов",
      "boxText": "Мы готовы помочь вам, в чем бы вы ни нуждались.",
      "chat": {
        "icon": "chat"
      },
      "customerService": {
        "title": "Клієнтська лінія",
        "buttonEmail": {
          "text": "ua@ulekare.cz"
        },
        "buttonPhone": {
          "text": "+420 227 072 720",
          "subtitle": ""
        },
        "linkEmail": "mailto:ua@ulekare.cz",
        "linkPhone": "tel:+420 227 072 720",
        "icon": "care"
      },
      "assistanceService": {
        "icon": "happy"
      },
      "covidService": {
        "icon": "lungs"
      },
      "unavailableOn": "Обращаем ваше внимание, что {date} служба поддержки клиентов и служба обработки заказов будут работать в ограниченном режиме. Обработка поступивших запросов может занять больше времени, чем обычно. Для получения общей информации, пожалуйста, напишите нам на указанный адрес электронной почты. \nБлагодарим за понимание.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Могу пользоваться службой бесплатно?",
    "requestSent": "Завершите регистрацию на рабочем e-mail",
    "hint": {
      "subtitle": "соучередитель uLékaře.cz, хирург",
      "text": "Светит солнце и цветут цветы. Что такое? Пришла весна!<br />А с ней аллергия, весенняя усталость, загорелая кожа, пятна на коже...",
      "linkText": "Хочу проконсультироваться"
    },
    "questions": {
      "myQuestions": "Мои вопросы",
      "updated": "У нас есть ответ для вас!",
      "resolvers": "Забочусь о вас",
      "sla": "Ответим до <strong class=\"black--text\">{hour}</strong> ч."
    },
    "appointments": {
      "myAppointments": "Мои записи"
    },
    "videoCall": {
      "buttonText": "Запланировать видеозвонок",
      "buttonTextMobile": "Видеозвонок"
    },
    "services": {
      "question": {
        "title": "Консультация (24/7)",
        "subtitle": "с ответом до {hours} ч.",
        "b2cSufix": "за {priceCzk} CZK",
        "text": "Семейные врачи и специалисты в одном месте. Для вас днем и ночью.",
        "button": "Необходима консультация"
      },
      "videoCall": {
        "title": "Видеозвонок",
        "subtitle": "с врачом",
        "text": "Врачи могут уделить вам до 20 минут видео разговора в то время, которое вы выберете.",
        "button": "Запланировать видеозвонок"
      },
      "appointment": {
        "title": "Запись",
        "subtitle": "по всей Чехии",
        "text": "Медсестры помогут вам найти врача, который вам необходим.",
        "button": "Хочу записаться"
      },
      "prevention": {
        "title": "Профилактика",
        "subtitle": "ваше здоровье - в ваших руках.",
        "text": "Здоровье принадлежит вам. Мы с удовольствием поможем вам о нем позаботиться ",
        "existedButton": "Войти в профилактику"
      },
      "thematic_counseling": {
        "title": "Тематические консультации",
        "text": "Печень или кожа? Задайте вопрос в онлайн консультациях, которые сосредотачиваются на конкретной медицинской теме.",
        "button": "Выбрать консультацию"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Эту службу вы не можете использовать на {language} языке. Пожалуйста, выберете другой язык <a href=\"{link}\" class=\"link--inline\">в настройках профиля</a>.",
          "cs": "чешском",
          "en": "английском",
          "sk": "словацком"
        }
      }
    },
    "news": "Новинки",
    "recomended": "Мы рекомендуем",
    "errors": {
      "emailNotVerified": "Пожалуйста, подтвердите электронную почту, указанную при регистрации. Чтобы uLékaře.cz был всегда под рукой!",
      "resendEmail": "Послать e-mail еще раз."
    },
    "family": {
      "title": "Хотите задать вопрос о своем здоровье?",
      "myHealth": "Да, о своем",
      "otherHealth": "Нет, о здоровье кого-то из семьи"
    },
    "emailVerification": {
      "title": "Подтверждение адреса электронной почты",
      "subtitle": "Перейдите в свой почтовый ящик <strong>{email}</strong> и нажмите на ссылку подтверждения в письме, которое мы вам отправили.",
      "text": [
        {
          "title": "Вы не получили письмо?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Возможно вы найдете письмо в папке “Спам”."
            },
            {
              "icon": "check_circle",
              "text": "Это может занять несколько минут. Все еще ничего? Попробуйте отправить электронное письмо ещё раз."
            }
          ]
        },
        {
          "text": "Не переживайте. Зарегистрируйтесь снова."
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Послать e-mail еще раз"
        }
      }
    },
    "help": {
      "text": " Требуется помощь?",
      "hours": "Пн–Пт 8:00-17:00"
    }
  },
  "videoCall": {
    "formStep": {
      "legal": {
        "personalData": {
          "text": "Личные данные обрабатываются в соответствии с"
        }
      }
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Выбрать подписку",
    "language": {
      "title": "Настройки службы",
      "text": "Выберите язык, на котором вы хотите пользоваться службой.",
      "errorText": "Текущий язык не поддерживается плательщиком службы. Выберите другой язык."
    },
    "final": {
      "title": "Регистрация прошла успешно",
      "text": "Теперь вы можете использовать службу uLékaře.cz. Наши врачи и медсестры всегда готовы помочь вам."
    },
    "possiblePartners": {
      "title": "Похоже, что у вас есть право на бесплатное пользование службой",
      "textHrb": "Подтвердите одного из перечисленных работодателей или партнеров, оплачивающих услугу. Не можете выбрать? Измените партнера.",
      "changePartner": "Изменить партнера"
    },
    "hrbPartner": {
      "title": "Активация бесплатной услуги",
      "textBoth": "Для активации введите корпоративный e-mail или активационный код, который вы получили от {partner}.",
      "textEmail": "Для активации введите корпоративный e-mail.",
      "textCode": "Для бесплатной активации услуги введите активационный код, который вы получили от {partner}.",
      "tabs": [
        "По e-mail",
        "По коду"
      ],
      "email": "Корпоративный e-mail",
      "code": "Активационный код",
      "codeError": "<strong>Данный код, к сожалению, недействителен.</strong><br>Пожалуйста, проверьте правильность кода в своем отделе кадров.<br>Если код правильный, мы будем рады помочь вам в",
      "emailError": "Недействительный e-mail. Не знаете, что делать? Свяжитесь с нами.",
      "invalidEmployeeEmail": "E-mail не разрешен для выбранного работодателя/партнера.",
      "benefitBlocked": "E-mail был использован у другого работодателя/партнера, активация невозможна."
    },
    "emailAuthorization": {
      "title": "Запрос на бесплатную активацию услуги отправлен",
      "text": [
        {},
        {
          "title": "Вы указали неверный e-mail?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            }
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Послать еще раз"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Кто оплачивает службу?",
      "text": "Воспользуйтесь услугами uLékaře.cz бесплатно! Возможно, ваш работодатель или один из наших партнёров (страховые компании, кредитные компании и т. д.) оплатит их.",
      "employees": "Работодатель",
      "search": "Ищите работодателя по названию",
      "searchSignText": "Начните писать название фирмы, в которой вы работаете. Мы найдем ее вместе.",
      "searchEmpty": {
        "title": "По запросу “{text}” нам не удалось найти ничего",
        "text": "Если вы считаете, что фирма должна быть в нашем списке, вы можете нам ее {email}.",
        "emailText": "порекомендовать"
      },
      "selfPay": "Оплачиваю сам"
    },
    "selfPay": {
      "title": "Оплачиваю сам",
      "text": "Так как вы оплачиваете сам, у вас есть доступ к следующему:",
      "price": "{priceCzk} CZK",
      "priceSufix": "/запрос",
      "list": [
        {
          "icon": "doctor",
          "text": "Ответ врача в течение 8 часов"
        },
        {
          "icon": "shield",
          "text": "Персонализированная программа профилактики"
        },
        {
          "icon": "news",
          "text": "Полезные здоровьесберегающие советы и статьи"
        }
      ]
    },
    "mastercard": {
      "title": "Подтвердите свою карту Mastercard<sup>®</sup>",
      "codeInvalidError": "Введенный номер недействителен. Проверьте, что вы вводите 6 цифр своей премиумной или корпоративной карты Mastercard<sup>®</sup>.",
      "label": "Первые 6 цифр с карты"
    },
    "external": {
      "titleSlot": "Проверка бесплатной услуги неуспешна",
      "vozpText": "Как клиент VoZP войдите в клиентский портал VoZP и нажмите на логотип uLékaře.cz. После первой авторизации вы получите доступ ко всем нашим службам.",
      "ozpText": "Клиентам OZP служба uLékaře.cz доступна 24/7 через VITAKARTA. Войдите в свой аккаунт VITAKARTA.",
      "drmaxText": "Как клиент Dr. Max авторизуйтесь в Karta výhodи и нажмите на лого uLékaře.cz.",
      "fairsuranceText": "Для активации бесплатной услуги введите авторизационный код, который вы получили в Fairsurance.",
      "eonText": "Бесплатное оказание услуг преданных клиентов E.ON больше не осуществляется. Вы можете и дальше пользоваться службой uLékaře.cz после того как войдете в свой аккаунт.",
      "sporthelpText": "{title}Для активации бесплатного пользования службой для членов спортивного страхования SportHelp перейдите по ссылке, которую вы найдете на своей цифровой карте клиента в разделе «Медицинская консультация» uLékaře.cz или «Запись» uLékaře.cz.",
      "defaultErrorText": "Ссылку для авторизации больше нельзя использовать, так как она утратила свою действительность. Спасибо за понимание."
    },
    "chooseDifferentCompany": "Изменить партнера"
  },
  "profile": {
    "title": "Мой аккаунт",
    "titleMobile": "Настройки",
    "subtitle": "Изменить свои данные.",
    "basicData": "Основные данные",
    "emailNote": "Изменение адреса электронной почты невозможно.",
    "phoneNote": "На этой номер Вам могут звонить наши медсестры при решение Ваших запросов.",
    "security": "Безопасность",
    "currentPassword": "Исходный пароль",
    "invalidCurrentPassword": "Недействительный исходный пароль",
    "currentPasswordUsedInHistory": "Новый пароль не должен быть таким же, как старый.",
    "newPassword": "Новый пароль",
    "additionalInfo": "Дополнительные данные",
    "birthDateNote": "Ответы врача будут точнее, если он будет знать Ваш возраст.",
    "address": "Адрес",
    "addressNote": "Адрес нам поможет найти подходящего Вам врача.",
    "family": "Моя семья",
    "aboutApp": "О приложении",
    "applicationLock": "Замок на приложение",
    "moreOptions": "Остальные возможности",
    "healthInsuranceProvider": {
      "title": "Страховая компания",
      "note": "Ищем врача сотрудничающего с Вашей страховкой."
    },
    "applicationLanguage": {
      "title": "Язык приложения",
      "message": "На этом языке будет отображаться сайт"
    },
    "serviceLanguage": {
      "title": "Язык службы",
      "message": "На этом языке Вам будет отвечать врач"
    },
    "changeLanguageNotification": {
      "text": "После сохранения изменений язык сайта поменяется на",
      "cs": "чешский",
      "en": "английский",
      "sk": "словацкий",
      "uk": "украинский",
      "ru": "русский"
    },
    "storeMessage": {
      "success": "Изменения сохранены.",
      "error": "Изменения не были сохранены. Проверьте правильность данных.",
      "passwordError": "Изменения не были сохранены из-за неправильно заданного пароля."
    },
    "ucb": {
      "title": "Правовые документы и извещение",
      "text": "Обратите внимание, что UniCredit Bank Czech Republic and Slovakia, a.s. не несет ответственности за содержание и ход службы, предоставленной сотруднику. Использование этой услуги сотрудником является добровольным, а ответственность за предоставление услуги в виде медицинских советов несет поставщик услуг, компания uLékaře.cz, s.r.o., которая гарантирует, что медицинский совет предоставляется исключительно квалифицированным лицом в соответствии с действующими законами Чешской Республики. Сотрудникам рекомендуется перед использованием медицинской консультации тщательно ознакомиться с {terms_and_conditions}.",
      "termsAndConditions": "условиями пользования"
    },
    "removeSection": {
      "title": "Удаление учетной записи",
      "button": "Удалить учетную запись"
    },
    "removeDialog": {
      "list": [
        {
          "icon": "chat-empty"
        },
        {
          "icon": "surgeon"
        },
        {
          "icon": "person-sad"
        }
      ],
      "cancelButton": "Оставайтесь здоровы"
    },
    "benefit": {
      "showMore": "Показать больше"
    },
    "appSecurity": "Защита приложения"
  },
  "passwordRenewal": {
    "title": "Обновите свой пароль.",
    "subtitle": "Вам необходимо обновить пароль, так как срок действия вашего пароля истек.",
    "currentPassword": "Текущий пароль:",
    "newPassword": "Новый пароль:",
    "passwordRules": "Ваш пароль должен состоять не менее чем из 8 символов, содержать как минимум одну букву, цифру и специальный символ (-=%*+./![]@#$^&()?;), и вы не должны использовать тот же пароль, который вы использовали в прошлом.",
    "confirmation": "Подтвердите новый пароль",
    "passwordsDontMatch": "Пароли не совпадают",
    "button": "Изменить пароль",
    "thankYouTitle": "Пароль был изменен",
    "thankYouSubtitle": "Ваш пароль был успешно изменен. Спасибо за сотрудничество!"
  },
  "questions": {
    "title": "Консультация",
    "subtitle": "Спросите наших врачей. Они отвечают в любое время дня и ночи. ",
    "noQuestion": {
      "title": "Мы всё ещё ждём ваш первый вопрос",
      "subtitle": "Как мы вам можем помочь?",
      "infoList": [
        {
          "text": "Мы немедленно вам посоветуем, сможете ли вы справиться с внезапной проблемой со здоровьем самостоятельно или же вам потребуется медицинская помощь.",
          "icon": "suitcase"
        },
        {
          "text": "Наш врач вам порекомендует необходимое обследование или правильного специалиста.",
          "icon": "surgeon-question"
        },
        {
          "text": "Непонятная медицинская документация или результаты лабораторных исследований? Наши специалисты вам с радостью все объяснят.",
          "icon": "stop"
        },
        {
          "text": "Без стеснения онлайн. Врач с удовольствием проконсультирует по вопросам здоровья вас и ваших близких.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "Новый вопрос",
    "newSolved": "Прочитайте ответ",
    "waitingForAnswer": "Ожидает ответа",
    "history": "Отвеченные вопросы",
    "detail": {
      "title": "Детали вопроса",
      "sent": "Отправленный вопрос",
      "questionFormTitle": "Описание проблемы со здоровьем",
      "healthFormTitle": "Состояние здоровья",
      "attachments": "Вложения",
      "helped": "Вам помог ответ?"
    },
    "evaluation": {
      "title": "Благодарим вас за ваш отклик",
      "text": "Вы помогаете нам улучшать наш сервис. Хотите сообщить нам что-то еще?",
      "label": "Другие комментарии и замечания",
      "placeholder": "Как можем улучшить наш сервис?",
      "ok": "Ответ мне помог",
      "nok": "Ответ мне не помог"
    },
    "thankYou": {
      "title": "Благодарим вас за отправку вопроса",
      "subtitle": "(Общение будет осуществляться на {language} языке)",
      "cs": "чешском",
      "en": "английском",
      "sk": "словацком",
      "text": "Врач общей практики в данный момент занимается вашим вопросом. Вы получите письмо на почтовый ящик сразу же как он ответит."
    },
    "status": {
      "waitingGpAnswer": "Ваш вопрос ожидает ответа от врача общей практики.",
      "waitingSpecialistAnswer": "Ваш вопрос ожидает ответ от специализированного врача.",
      "answered": "Врач ответил на ваш вопрос.",
      "transferToAppointment": "Ваш вопрос теперь имеет статус заявки. Мы скоро с вами свяжемся.",
      "declined": "Мы были вынуждены отклонить вопрос.",
      "emergency": "Врач ответил и передает: \"Немедленно обратитесь в ближайший пункт неотложной медицинской помощи. Ваше состояние может представлять угрозу для жизни.."
    },
    "askedQuestions": "Размещенные вопросы"
  },
  "appointments": {
    "title": "Мои заявки",
    "subtitle": "Наши медсестры с радостью помогут вам найти необходимого врача/специалиста или записаться к вашему врачу.",
    "statuses": {
      "newDoctor": "Мы нашли врача!",
      "newZZ": "Мы нашли, где вам могут помочь!"
    },
    "noAppointments": {
      "title": "Вы еще не пробовали записываться с помощью uLékaře.cz.",
      "subtitle": "Как работает запись с помощью uLékaře.cz?",
      "infoList": [
        {
          "text": "Помогаем с записью по всей Чехии и Словакии.",
          "icon": "hospital"
        },
        {
          "text": "Медсестра с вами свяжется а следующий рабочий день, и вы договоритесь обо всем необходимом, чтобы вы могли быстро попасть к правильному врачу.",
          "icon": "nurse"
        },
        {
          "text": "Позвольте нам позаботиться о поиске врачей и звонках в клиники.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "Новая заявка",
    "activeAppointments": "В процессе",
    "visitAppointments": "Не забудьте посетить врача",
    "evaluateAppointments": "Оцените визит к врачу",
    "history": "Завершенные заявки",
    "evaluation": {
      "ok": "Визит оставил приятное впечатление",
      "nok": "Визит вызвал недовольство",
      "noVisit": "Визит к врачу не состоялся"
    },
    "detail": {
      "title": "Детали заявки",
      "sent": "Отправлено",
      "date": "Дата записи: ",
      "visitAt": "Когда явиться: ",
      "facility": "Медицинское учреждение: ",
      "address": "Адрес: ",
      "doctor": "Врач: ",
      "phone": "Телефон: ",
      "note": "Примечание: ",
      "dateMandatory": "Указанная дата записи к врачу обязательна!",
      "unableToVisitInfo": "Если вы не можете явиться на запланированный визит к врачу, пожалуйста, звоните по номеру {phone} или пишите на <a href=\"mailto:{email}\">{email}</a>.",
      "thankYou": "Мы верим, что вам поможет рекомендованный нами врач в решении ваших вопросов связанных со здоровьем. Пожалуйста, дайте нам знать, как все прошло. Спасибо!",
      "additionalQuestion": "У меня есть дополнительный вопрос",
      "changeDate": "Поменять дату визита",
      "cancelAppointment": "Отменить запись",
      "helped": "Как вы оцените запись к врачу?",
      "noVisit": "Не состоялась"
    },
    "thankYou": {
      "subtitle": "(Общение будет осуществляться на {language} языке)",
      "cs": "чешском",
      "en": "английском",
      "sk": "словацком",
      "text": "Наша медсестра позвонит вам с номера +420 227 072 720 в следующий рабочий день.",
      "others": {
        "text": "Медсестру будет интересовать следующие данные о человеке, которого вы хотите записать к врачу:",
        "items": [
          {
            "icon": "register",
            "text": "номер страхования и страховка"
          },
          {
            "icon": "person-happy",
            "text": "текущее состояние здоровья"
          },
          {
            "icon": "news",
            "text": "пройденные обследования и направления"
          },
          {
            "icon": "clock",
            "text": "время, в которое вы можете посетить врача"
          }
        ]
      }
    },
    "status": {
      "waiting": "Медсестра скоро займется вашим запросом и сразу свяжется с вами.",
      "lookingForDoctor": "В данный момент мы ищем для вас необходимого врача.",
      "orderedForTime": "Ваш визит назначен на {datetime}.",
      "orderedForOpeningHours": "Мы договорились! Вас примут в кабинете в рабочее время.",
      "sendContact": "Мы послали вам контакт на врача.",
      "done": "Все готово, вы записаны!",
      "cancelled": "Запись была отменена."
    }
  },
  "prevention": {
    "title": "Начните профилактику. Это залог вашего здоровья.",
    "subtitle": "Достаточно нескольких личных данных, и мы подготовим для вас профилактическую программу для вашего тела. Предотвращение проблем со здоровьем будет гораздо проще.",
    "birthDateNote": "Возраст - всего лишь число. Нам необходимо его знать, чтобы предоставить правильный уход.",
    "healthInsuranceProviderNote": "Вы увидите бонусы вашей страховой компании, а также мы поможем вам с записью к сотрудничающим врачам.",
    "personalization": {
      "title": "Ваши обследования в зависимости от возраста.",
      "text": "При выключении вы также увидите профилактические обследования, которые обычно проводятся в старшем возрасте."
    },
    "start": "Начать профилактику",
    "thankYou": {
      "title": "Готово! Благодарим за заполнение всех данных.",
      "text": "Благодаря профилактическому уходу вы предотвратите проблемы со здоровьем. Советы и новости связанные с заботой о здоровье регулярно будут поступать к вам на электронную почту."
    },
    "summary": {
      "title": "Профилактика",
      "subtitleDesktop": "Мы поможем вам быть на шаг впереди болезней.",
      "subtitleMobile": "На шаг впереди болезней.",
      "showAll": "Показать всё",
      "intervalEnds": "Запишитесь в ближайшее время",
      "planned": "Запланировано",
      "plannedOn": "Запланировано на {time}",
      "timeline": {
        "title": "На очереди",
        "tooltip": "Здесь вы увидите ближайшие обследования и вакцинации – вы уже записаны?"
      },
      "examinations": {
        "title": "Профилактические обследования",
        "tooltip": "Здесь вы найдете даты осмотров и всю информацию, касательно того что вас ждет."
      },
      "vaccinations": {
        "title": "Вакцинация",
        "tooltip": "Здесь вы найдете даты вакцинаций и всю информацию, касательно того что вас ждет."
      },
      "others": {
        "title": "Полезная информация"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Обязательные обследования",
        "optional": "Добровольные обследования"
      },
      "vaccinations": {
        "recommended": "Обязательные вакцинации",
        "optional": "Добровольные вакцинации"
      }
    }
  },
  "payment": {
    "title": "Выберете способ оплаты",
    "priceSum": "Всего: {price} CZK",
    "voucher": "Код вашего ваучера",
    "voucherGroup": "Ваучером {region}",
    "voucherApply": "Принять",
    "pay": "Оплатить ({price} CZK)",
    "payment_created": "Оплата еще не поступила.",
    "payment_confirmed": {
      "title": "Благодарим за вопрос!",
      "subtitle": "Вопрос уже направлен к врачу общей практики, который скоро начнет его рассматривать. Как только появится ответ, мы сообщим вам по электронной почте."
    },
    "payment_canceled": "Платеж был отменен.",
    "payment_rejected": "Ваш платеж был отклонен.",
    "payment_create_error": "Оплата не прошла. Попробуйте еще раз.",
    "payment_timeouted": "Оплата не прошла. Попробуйте еще раз.",
    "payment_in_progress": "Мы ожидаем оплату.",
    "payment_wait": {
      "title": "Ожидаем проверку оплаты.",
      "subtitle": "Jakmile bude platba ověřená, předáme dotaz lékařům.Мы передадим вопрос врачам, как только платеж будет подтвержден."
    },
    "chooseDifferent": "Выбрать другой метод"
  },
  "loginBanner": {
    "title": "Мы ваш проводник на пути к здоровью.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "Семейные врачи и специалисты отвечают на вопросы"
      },
      {
        "icon": "nurse",
        "text": "Медсестры помогут с записью к врачу."
      },
      {
        "icon": "shield",
        "text": "Защищенная платформа полностью в ваших руках."
      }
    ],
    "show": "Как работает служба?",
    "hide": "Закрыть"
  },
  "cookiesConsent": {
    "acceptAll": "Принять всё",
    "basic": {
      "title": "Наш сайт работает как доктор",
      "perex": "Наш сайт использует файлы cookie и поэтому работает как врач, который задает необходимые вопросы, чтобы помочь вам как можно лучше. Таким образом мы собираем {technical}, {analytical} и {marketing} информацию, чтобы постоянно совершенствоваться и лучше помогать всем вам. Вы согласны?",
      "technical": "техническую",
      "analytical": "аналитическую",
      "marketing": "деловую",
      "customize": "Настройки"
    },
    "settings": {
      "title": "Настройка файлов cookie",
      "description": "Посещая наш веб-сайт www.ulekare.cz, сайт получает или сохраняет информацию на вашем браузере, обычно в виде файлов cookie. Это могут быть сведения о вас, ваших предпочтениях и устройствах, которые вы используете. Обычно это используется для улучшения сайта и его работы в соответствии с вашими ожиданиями. Эти сведения обычно не идентифицируют вас как личность, но в целом они могут помочь адаптировать сайт к вашим потребностям. Мы уважаем ваше право на конфиденциальность, и поэтому вы можете решить не принимать некоторые файлы cookie, согласно вашему выбору ниже. Имейте в виду, что блокировка некоторых файлов cookie может повлиять на работу сайта и отображение вам предоставляемых услуг.",
      "link": "Декларацию о файлах Cookie можно найти {hereLink}.",
      "items": {
        "technical": {
          "title": "Технические файлы cookie",
          "bodyText": "Необходимы для работы наших страниц, поэтому их нельзя отключить. Обычно они устанавливаются в ответ на действия, которые вы совершаете, такие как запрос услуг, связанных с безопасностью, вход в систему, заполнение форм и т. д. Вы можете настроить свой браузер так, чтобы он блокировал файлы cookie или уведомлял вас о них. Эти файлы cookie не хранят никакой идентифицирующей информации."
        },
        "functional": {
          "title": "Функциональные файлы cookie",
          "bodyText": "Эти файлы cookie делают страницу более производительной и персонализированной. Их можем настраивать мы или третьи поставщики услуг, службы которых мы используем на нашем сайте. Если вы не разрешите использование этих файлов cookie, некоторые или все эти службы могут работать некорректно."
        },
        "analytics": {
          "title": "Аналитические файлы cookie",
          "bodyText": "Эти файлы cookie используются для улучшения работы веб-сайта. Они позволяют нам распознавать и отслеживать количество посетителей и узнавать, как они используют веб-сайт. Они помогают нам улучшить работу веб-сайта. Эти файлы cookie не собирают информацию, которая идентифицирует вас как личность."
        },
        "marketing": {
          "title": "Маркетинговые файлы cookie",
          "bodyText": "Используются для отслеживания предпочтений пользователя веб-сайта с целью таргетированной рекламы, то есть отображения маркетинговых и рекламных сообщений (даже на сторонних веб-сайтах) в соответствии с этими предпочтениями. <strong>Маркетинговые файлы cookie используют инструменты сторонних компаний. Эти маркетинговые файлы cookie будут использоваться только с вашего согласия</strong>."
        }
      },
      "save": "Сохранить настройки"
    },
    "youtube": {
      "text": "Для просмотра видео нам нужно подтвердить использование файлов cookie. Более подробную информацию можно найти в {cookiePolicyLink}.",
      "cookiePolicyLinkText": "правила использования файлов cookie",
      "accept": "Я согласен"
    }
  },
  "placeholders": {
    "date": {
      "year": "ГГГГ",
      "month": "ММ",
      "date": "ДД"
    }
  },
  "putinSucks": {
    "helloImage": "hello-ua-tp-figure.svg",
    "helloImageAlt": "Врачебная консультация для беженцев из Украины",
    "menu": {
      "question": "Проконсультироваться",
      "helpWith": "Как работает сервис?",
      "logoText": "Мы за Украину"
    },
    "subTitle": "Врачебная консультация для украинцев",
    "doctorInfo": {
      "text": "“Не стесняйтесь обращаться к нам с любой проблемой со здоровьем, которую вам нужно решить в Чешской Республике. Наши врачи и медсестры, говорящие на украинском и русском языках, будут рады проконсультировать Вас.“",
      "name": "MUDr. Соня Боушкова",
      "position": "Главный врач uLékaře.cz"
    },
    "infoTitle": "Как работает сервис?",
    "infoListHeader": [
      {
        "icon": "icon-check-ua",
        "text": "Консультация врача по всей Чешской Республике."
      },
      {
        "icon": "icon-check-ua",
        "text": "Врачи и медсестры позаботятся о вас на Вашем родном языке."
      },
      {
        "icon": "icon-check-ua",
        "text": "Мы упростили для Вас сервис, все, что Вам нужно, это электронная почта и номер телефона."
      }
    ],
    "infoList": [
      {
        "icon": "ua/register",
        "text": "Опишите Вашу проблему в бланк ниже."
      },
      {
        "icon": "ua/mail",
        "text": "Врач ответит Вам по электронной почте."
      },
      {
        "icon": "ua/objednavky",
        "text": "Медсестры помогут Вам с записью."
      }
    ],
    "form": {
      "thankYou": {
        "title": "Мы будем рады вам помочь",
        "perex": "<p>Врач свяжется с Вами по электронной почте, eсли Вам нужно будет обратиться к врачу, то с Вами свяжется медсестра.</p>"
      }
    },
    "footer": {
      "perex": "У uLékaře.cz мы верим, что здоровье принадлежит Вам. Благодаря технологиям, человеческому подходу и медицинскому опыту мы помогаем людям заботиться об их здоровье."
    }
  },
  "unavailableClinics": {
    "title": "Минутку, проходит актуализация!",
    "description": "Приносим извинения за кратковременное прекращение работы. Сервис скоро вернется… и будет даже лучше, чем раньше."
  },
  "healthInsuranceProviderBenefits": {
    "title": "Выберите страховую компанию"
  },
  "invitation": {
    "dashboard": {
      "title": "Пригласите семью",
      "text": "Служба uLékaře.cz для ваших близких. Полностью бесплатно.",
      "buttonText": "Послать приглашение"
    },
    "title": "Здоровье для всей семьи",
    "text": "Вы можете пригласить до 5 близких людей. Благодаря вам они могут бесплатно иметь под рукой уход врачей и медсестер.",
    "list": [
      {
        "icon": "link",
        "text": "Скопируйте вашу уникальную ссылку для приглашения членов семьи."
      },
      {
        "icon": "rodina",
        "text": "Пошлите ее своим близким."
      },
      {
        "icon": "confetti",
        "text": "После регистрации активируется бесплатное пользование службой."
      }
    ],
    "shareLink": "Ссылка для приглашения",
    "copyCode": "Копировать ссылку",
    "codeCopied": "Скопировано",
    "familyTitle": "Кому помогаю",
    "remove": "Удалить",
    "shareTitle": "Служба uLékaře.cz беслптано",
    "shareText": "{personName} делится с вами службой uLékaře.cz в рамках родины.Вам нужно просто пройти регистрацию перейдя по ссылке и вы можете пользоваться услугами бесплатно.",
    "emptyMemberName": "Член семьи"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "boxes": {
      "noRecords": "Не заполнено"
    },
    "examination": {
      "todayDateCheckboxLabel": ""
    }
  },
  "aeskulab": {
    "title": "Запрос на объяснение результатов лабораторных тестов",
    "buttonText": "Оставить запрос",
    "howItWorks": {
      "title": "Как это работает?",
      "items": [
        {
          "icon": "chat",
          "perex": "Отправьте запрос с приложенным pdf-документом с лабораторными результатами."
        },
        {
          "icon": "mail",
          "perex": "В течение 24 часов мы отправим вам объяснение лабораторных результатов на вашу почту."
        },
        {
          "icon": "calendar/date-31",
          "perex": "На следующий рабочий день после ответа врача с Вами свяжется медсестра и все обсудит с вами"
        }
      ]
    },
    "form": {
      "thankYou": {
        "title": "Благодарим за оставленный запрос.",
        "perex": "Ваши лабораторные результаты и все данные были только что отправлены на обработку.\nВы получите ответ от врача в течение 24 часов на свою электронную почту"
      },
      "personalData": {
        "text": "Я ознакомился с {link} поставщика медицинских услуг uLékaře.cz Health Care.",
        "link": "принципами обработки персональных данных"
      },
      "termsConds": {
        "text": " Я ознакомился с {link} и {cookies} и соглашаюсь с ними.",
        "link": "условиями использования платформы uLékaře.cz",
        "cookies": "принципами использования Cookie платформы uLékaře.cz"
      }
    },
    "formTitle": "Форма запроса",
    "email": "health.care@ulekare.cz",
    "phone": "+420 253 253 155",
    "formButtons": {
      "text": "Мы используем данные с сайта cz.unilabs.online",
      "others": "Запрос на другого человека"
    },
    "emergency": "Служба uLékaře.cz не заменяет службу скорой помощи. В случае острых проблем <a href=\"tel:155\" class=\"link--inline black--text\">звоните на номер 155.</a>",
    "footer": {
      "copyright": "© {thisYear} uLékaře.cz Health Care, s.r.o.",
      "leftText": "Поставщик медицинских услуг uLékaře.cz Health Care, s.r.o. Работу веб-сайта обеспечивает uLékaře.cz, s.r.o.",
      "rightText": "Unilabs владелец службы cz.unilabs.online и самый большой поставщик лабораторных услуг и диагностики в Чешской республике."
    }
  },
  "feedback": {
    "text": "Ваша оценка - наш витамин. Благодаря вам мы улучшаем состояние этого приложения.",
    "label": "У вас есть какие-то идеи по улучшению?",
    "placeholder": "Вы можете поделиться ими здесь...",
    "thankYou": {
      "title": "Благодарим за обратную связь",
      "text": "Мы сделаем все, чтобы забота о вашем здоровье была легче."
    },
    "menu": "Обратная связь",
    "panelButton": "Оставьте отзыв"
  },
  "newsletterAgreement": {
    "dashboard": {
      "text": "Новости и скидки будут приходить на вашу электронную почту."
    }
  },
  "addressInput": {
    "country": "Государство"
  },
  "secondFactor": {
    "label": "Введите код, который вы получили для подтверждения входа.",
    "error": {
      "input": "Введите код."
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "birthNumber": {
          "self": {
            "label": "Страховой номер",
            "help": "Номер страховки облегчит нам запись на прием к хирургу."
          },
          "other": {
            "label": "Страховой номер",
            "help": "Номер страховки облегчит нам запись на прием к хирургу."
          }
        }
      },
      "questionBasic": {
        "questionWhat": {
          "label": "Пожалуйста, опишите проблему, что вас беспокоит и все ее проявления. Чем подробнее вы дадите описание, тем точнее вам ответит врач."
        }
      },
      "questionAdditional": {
        "questionContact": {
          "yes": "Да, я хотел бы, чтобы со мной связалась медсестра.",
          "no": "Нет, я не хочу, чтобы медсестра звонила."
        }
      }
    },
    "Order": {
      "patient": {
        "firstName": {
          "other": {
            "label": "Имя другого человека"
          }
        },
        "birthNumber": {
          "self": {
            "label": "Страховой номер",
            "help": "Номер страховки облегчит нам запись на прием к хирургу."
          },
          "other": {
            "label": "Страховой номер",
            "help": "Номер страховки облегчит нам запись на прием к хирургу."
          }
        }
      },
      "orderBasic": {
        "orderWhat": {
          "label": "С чем вам могут помочь медсестры?"
        },
        "orderSpecialist": {
          "label": "Какой врач или специалист вам нужен?"
        },
        "orderContact": {
          "label": "Как вы хотите помочь с заказом?",
          "yes": "Я предпочитаю взять на себя весь процесс заказа.",
          "no": "Я предпочитаю отправлять контакты."
        }
      }
    }
  }
}